import { createSlice } from '@reduxjs/toolkit'

export const ProjectRequestListSlice = createSlice(
  {
  name: 'project_request_list',
  initialState: {
    value: {},
  },
  reducers: {
    updateProjectRequestList: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateProjectRequestList } = ProjectRequestListSlice.actions

export default ProjectRequestListSlice.reducer